import { FeeAnalysisLabelConstants } from "@pages/platform-analysis/_id/steps/fee/analysis/constants";

export class ExcelLabelConstants {
  static readonly HeaderPlatformAnalysis =
    "SuitabilityHub platform and managed account portfolio fee analysis summary";
  static readonly HeaderReview =
    "SuitabilityHub platform and managed account portfolio fee review summary";
  static readonly FamilyGroup = "Family group:";
  static readonly LastEdit = "Last edit:";
  static readonly DataValid = "Data valid:";
  static readonly PortfolioDetail = "Portfolio details for fee estimates";
  static readonly IDPSAccount = "Value of each IDPS account:";
  static readonly SuperAccount = "Value of each super/pension account:";
  static readonly TotalPortfolio = "Total portfolio value:";
  static readonly PlatformFeeAverage =
    "Platform fees by average total balance for the year";
  static readonly MissingInvestmentOption =
    "*Product is missing some investment options";
  static readonly FeeReviewDisclaimer =
    "Fee review disclaimer and assumptions apply. See web version for details";
  static readonly FeeAnalysisDisclaimer =
    "Fee analysis disclaimer and assumptions apply. See web version for details";
  static readonly TotalPortfolioSize = "Total portfolio size";
  static readonly BelowMinimumInvestmentSize =
    "**Allocation below minimum investment size";
}

export const ExcelSubTitle = {
  Internal: "For internal use only",
  Supplier: (supplierName: string) =>
    `For ${supplierName} internal use only. Not to be disseminated`,
  Adviser: (adviserName: string, practiceName: string) =>
    `For ${adviserName} of ${practiceName} use only. Not to be disseminated`,
};

export class FeeEstimatesTableLabelConstants {
  static readonly TotalPlatformAndSMAFees: string =
    "Total platform & managed account portfolio fees";
  static readonly TotalPlatformFees: string = "Total platform fees";
  static readonly PlatformFees: string = "Platform fees";
  static readonly ManagedAccountFees: string =
    "Managed account portfolio fees (excludes other investments)";
  static readonly ManagedAccountFeesExcPerf: string =
    "Managed account portfolio fees (excluding performance fees and any other investments)";
  static readonly IDPSAdminAndAccountFees: string =
    "IDPS administration and account fees";
  static readonly SuperAdminAndAccountFees: string =
    "Super/pension administration and account fees";
  static readonly InternationalAndBondHoldingFees: string =
    "International security & bond holding fees";
  static readonly ExpenseRecoveryAndOtherFees: string =
    "Expense recovery & other fees";
  static readonly TransactionFeesNonSMA: string =
    "Transaction fees (non-managed account)";
  static readonly TransactionFees: string = "Transaction fees";
  static readonly PYSRefund: string = "PYS refund";
  static readonly SMAFees: string = "SMA fees";
  static readonly SMAFeesExcPerf: string = "SMA fees (exc. perf.)";
  static readonly CashFees: string = "Cash fees";
  static readonly NetInterestEarnedOnCash: string =
    "Net interest earned on cash (after cash fees)";
  static readonly PlatformFeeBreakdown = "Platform fees breakdown";
}

export const FeeEstimatesTableLabelMap: Record<string, string> = {
  [FeeAnalysisLabelConstants.TotalPlatformAndSMAFees]:
    FeeEstimatesTableLabelConstants.TotalPlatformAndSMAFees,
  [FeeAnalysisLabelConstants.TotalFees]:
    FeeEstimatesTableLabelConstants.TotalPlatformFees,
  [FeeAnalysisLabelConstants.IDPSAdminAndAccountFees]:
    FeeEstimatesTableLabelConstants.IDPSAdminAndAccountFees,
  [FeeAnalysisLabelConstants.SuperAdminAndAccountFees]:
    FeeEstimatesTableLabelConstants.SuperAdminAndAccountFees,
  [FeeAnalysisLabelConstants.InternationalAndOtherHoldingFees]:
    FeeEstimatesTableLabelConstants.InternationalAndBondHoldingFees,
  [FeeAnalysisLabelConstants.ExpenseRecoveryAndOtherFees]:
    FeeEstimatesTableLabelConstants.ExpenseRecoveryAndOtherFees,
  [FeeAnalysisLabelConstants.TransactionFeesNonSMA]:
    FeeEstimatesTableLabelConstants.TransactionFeesNonSMA,
  [FeeAnalysisLabelConstants.TransactionFees]:
    FeeEstimatesTableLabelConstants.TransactionFees,
  [FeeAnalysisLabelConstants.SMAFees]: FeeEstimatesTableLabelConstants.SMAFees,
  [FeeAnalysisLabelConstants.SMAFeesExcPerf]:
    FeeEstimatesTableLabelConstants.SMAFeesExcPerf,
  [FeeAnalysisLabelConstants.PYSRefund]:
    FeeEstimatesTableLabelConstants.PYSRefund,
  [FeeAnalysisLabelConstants.CashFees]:
    FeeEstimatesTableLabelConstants.CashFees,
  [FeeAnalysisLabelConstants.NetInterestEarnedOnCash]:
    FeeEstimatesTableLabelConstants.NetInterestEarnedOnCash,
};

export const ExcludedFeeTypes = [
  FeeAnalysisLabelConstants.TotalFees,
  FeeAnalysisLabelConstants.TotalPlatformAndSMAFees,
  FeeAnalysisLabelConstants.SMAFees,
];
